<ng-container class="flex flex-col h-full">
    <div class="flex justify-between flex-row items-center mb-4">
        <div class="flex">
            @if (showBackButton()) {
                <fa-icon
                    class="pr-2 self-center hover:text-primary transition-colors cursor-pointer text-custom-blue"
                    size="xl"
                    [icon]="['far', 'arrow-left']"
                    [matTooltip]="'back' | transloco"
                    (click)="onBackClick()" />
            }
            <span
                class="font-medium p-0"
                [class]="titleSize() ?? 'text-2xl'">
                {{ title() }}
            </span>
        </div>
        @if (canClose()) {
            <fa-icon
                class="ml-4 cursor-pointer text-custom-dark-grey"
                size="xl"
                [icon]="['far', 'close']"
                [mat-dialog-close]="true"
                (click)="onClickEvent.emit(ModalResultEnum.CANCEL)" />
        }
    </div>

    <div class="flex-grow">
        <ng-content />
    </div>

    <div class="flex items-center justify-between gap-4 mt-2">
        @if (isSearchbarActive()) {
            <app-search
                [dense]="true"
                [hasDebounce]="true"
                [labelKey]="searchLabelKey()"
                [showLabel]="false"
                (searchValue)="updateSearchTerm($event)" />
        }
        @if (messageInformation()) {
            <p class="custom-information-message">
                {{ messageInformation() | transloco }}
            </p>
        }

        @if (isConfirmationMode()) {
            <div
                class="flex gap-4 p-4"
                mat-dialog-actions>
                <ng-content select="[modalActions]" />

                @if (canCancel()) {
                    <app-button
                        [label]="'cancel' | transloco"
                        [type]="ButtonType.SECONDARY"
                        (onClick)="onCancelClick.emit()" />
                }

                <app-button
                    data-testid="modal-confirm-btn"
                    iconSize="sm"
                    [disabled]="!canConfirm()"
                    [icon]="confirmIcon() ?? undefined"
                    [label]="buttonLabel()"
                    [tooltip]="confirmTooltip()"
                    [type]="ButtonType.PRIMARY"
                    (onClick)="isLastStep() ? onClickEvent.emit(ModalResultEnum.CONFIRM) : nextStep()" />
            </div>
        }
    </div>
</ng-container>
